"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var authentication_1 = require("./browser/initializers/authentication");
var booking_tooltip_1 = require("./browser/initializers/booking_tooltip");
var booking_wiget_1 = require("./browser/initializers/booking_wiget");
var chats_notificator_1 = require("./browser/initializers/chats_notificator");
var event_bus_1 = require("./browser/initializers/event_bus");
var favorite_button_1 = require("./browser/initializers/favorite_button");
var newbuilding_mvk_1 = require("./browser/initializers/newbuilding_mvk");
// tslint:disable:no-any
window.__authenticationCreateContext = authentication_1.createContext;
window.__authenticationInsert = authentication_1.insert;
window.__authenticationOpen = authentication_1.open;
window.__authenticationClose = authentication_1.close;
window.__initializeChatsNotificator = chats_notificator_1.initializeChatsNotificator;
window.__initializeBookingTooltip = booking_tooltip_1.initializeBookingTooltip;
window.__initializeBookingWidget = booking_wiget_1.initializeBookingWidget;
window.__initializeFavoriteButton = favorite_button_1.initializeFavoriteButton;
window.__initializeNewbuildingMVK = newbuilding_mvk_1.initializeNewbuildingMVK;
window.__getEventBusIfDefined = event_bus_1.initializeEventBus;
// tslint:enable:no-any



//////////////////
// WEBPACK FOOTER
// ./src/index.ts
// module id = 123
// module chunks = 2